import { SpiderType } from '../types/spiders';

/** this function has a stricter scope so more callers can use it. */
export const hasSpiderType = (types: SpiderType[]) => (
  spiders: { vehicleId: string; spiderType: SpiderType }[]
) => (aircraft: { id: string }) =>
  spiders.some(s => s.vehicleId === aircraft.id && types.includes(s.spiderType));
